const translation = {
  Product: "उत्पाद",
  "Header.productNav": "LUKKEY उत्पाद",
  Feature: "विशेषता",
  "About Us": "हमारे बारे में",
  FAQ: "सामान्य प्रश्न",
  "Privacy Policy": "गोपनीयता नीति",
  "Help Center": "सहायता केंद्र",
  "Header.infoMenu": "और",
  "Header.appNow": "ऐप डाउनलोड करें",
  "Header.appModal.title": "अभी LUKKEY ऐप इस्तेमाल करें",
  "Header.appModal.subtitle": "आधिकारिक LUKKEY मोबाइल ऐप पाने के लिए अपना प्लेटफ़ॉर्म चुनें।",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "iPhone पर आधिकारिक ऐप इंस्टॉल करें।",
  "Header.appModal.iosButton": "खोलें",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Google Play पर आधिकारिक Android ऐप प्राप्त करें।",
  "Header.appModal.googlePlayButton": "खोलें",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "नवीनतम आधिकारिक APK सीधे डाउनलोड करें।",
  "Header.appModal.androidButton": "डाउनलोड",
  "Header.appModal.note": "केवल आधिकारिक मोबाइल डाउनलोड। नवीनतम संस्करण के लिए ऊपर दिए गए लिंक का उपयोग करें।",
  "Academy": "अकादमी",
  "Legal": "कानूनी जानकारी",
  "AboutUs.title": "LUKKEY के बारे में",
  "AboutUs.lede": "LUKKEY एक स्विस हार्डवेयर वॉलेट ब्रांड है जो डिजिटल एसेट स्वामित्व के लिए सुरक्षा के सर्वोच्च मानक बनाने के लिए समर्पित है।",
  "AboutUs.vision.closing": "आपकी कुंजियाँ। आपकी संपत्ति। आपका भविष्य।",
  "AboutUs.quote": "LUKKEY लोगों और डिजिटल एसेट्स के बीच सुरक्षा की परत बनाता है।",
  "AboutUs.block1": "LUKKEY स्विट्ज़रलैंड में आधारित है। यह सुरक्षित सेल्फ-कस्टडी के लिए डिज़ाइन किए गए हार्डवेयर वॉलेट्स पर केंद्रित है।",
  "AboutUs.block2": "इसके उत्पाद secure element, छेड़छाड़-रोधी सुरक्षा और पूरी तरह ऑफलाइन आर्किटेक्चर को जोड़ते हैं। लक्ष्य यह है कि private keys एक अलग-थलग वातावरण में रहें।",
  "AboutUs.block3": "सिस्टम को Wi‑Fi, USB या सीधे नेटवर्क निर्भरता के बिना डिज़ाइन किया गया है। फिंगरप्रिंट एक्सेस, NFC बैकअप टूल्स और व्यापक एसेट सपोर्ट इसे रोज़मर्रा के उपयोग में व्यावहारिक बनाते हैं।",
  "AboutUs.block5": "LUKKEY कोर firmware और software के लिए खुला और audit योग्य दृष्टिकोण अपनाता है। सुरक्षा दावों को जाँचा और सत्यापित किया जा सकना चाहिए।",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "सहायता अनुरोध",
  "WarrantySupport.intro": "कृपया अपना सहायता अनुरोध भेजने के लिए नीचे दी गई जानकारी भरें।",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "समस्या का सार",
  "WarrantySupport.form.issueTitle.placeholder": "एक संक्षिप्त सार लिखें",
  "WarrantySupport.form.warrantyType.label": "अनुरोध का प्रकार",
  "WarrantySupport.form.warrantyType.placeholder": "अनुरोध का प्रकार चुनें",
  "WarrantySupport.form.warrantyType.product": "डिवाइस समस्या",
  "WarrantySupport.form.warrantyType.service": "ऐप/खाता समस्या",
  "WarrantySupport.form.warrantyType.replacement": "अन्य",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "समस्या या अनुरोध का विवरण दें",
  "WarrantySupport.form.submit": "सहायता अनुरोध भेजें",
  "WarrantySupport.alert.success": "आपका सहायता अनुरोध भेज दिया गया है!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "सहायता केंद्र",
  "HelpCenter.intro":
    "LUKKEY हेल्प सेंटर में आपका स्वागत है! यदि आप क्रिप्टोकरेंसी में नए हैं या अपने कोल्ड वॉलेट के लिए मदद चाहिए, तो आप सही जगह पर हैं। हमारा कोल्ड वॉलेट समाधान आपके डिजिटल एसेट्स को सुरक्षित रूप से स्टोर और मैनेज करने का सबसे सुरक्षित तरीका प्रदान करता है। नीचे आपको सामान्य प्रश्नों के उत्तर और समस्या-समाधान के सुझाव मिलेंगे।",
  "HelpCenter.section4.title": "क्या आपको और सहायता चाहिए?",
  "HelpCenter.section4.intro":
    "ऑनलाइन सहायता अनुरोध शुरू करके समय बचाएँ, और हम आपको किसी विशेषज्ञ से जोड़ देंगे। आपकी सुरक्षा के लिए, आधिकारिक सहायता कभी भी आपकी रिकवरी फ्रेज या प्राइवेट की नहीं मांगेगी:",
  "HelpCenter.contact.hint": "बटन से सहायता अनुरोध भेजें, हम ईमेल के माध्यम से संपर्क करेंगे।",
  "HelpCenter.cta.warranty": "सहायता अनुरोध भेजें",
  brandName: "LUKKEY",
  tagline:
    "अपनी क्रिप्टोकरेंसी को पहले से कहीं अधिक स्मार्ट तरीके से प्रबंधित करें",
  description:
    "हमारे ऐप के साथ वित्तीय स्वतंत्रता की ओर अपना सफर शुरू करें। हमारी उन्नत कोल्ड वॉलेट तकनीक के साथ अपने संपत्तियों को सुरक्षित रखें और अपनी वित्तीय स्थिति को और अधिक स्मार्ट और प्रभावी तरीके से प्रबंधित करें। आपकी वित्तीय भलाई हमारी प्राथमिकता है।",
  "home.seoTitle": "LUKKEY | सुरक्षित सेल्फ-कस्टडी के लिए स्विस हार्डवेयर वॉलेट",
  "home.seoDescription": "LUKKEY एक स्विस हार्डवेयर वॉलेट ब्रांड है जो cold wallet सुरक्षा, private key की ऑफलाइन सुरक्षा, fingerprint access और NFC backup पर केंद्रित है, ताकि self-custody अधिक सुरक्षित हो सके।",
  learnMore: "अधिक जानें",
  "Lock Your Crypto, Securely": "अपने क्रिप्टो को सुरक्षित रूप से लॉक करें",
  Testimonials: "प्रमाणपत्र",
  Testimonial1:
    "मैं इस कोल्ड वॉलेट का महीनों से उपयोग कर रहा हूं, और इसकी विश्वसनीयता और सुरक्षा विशेषताओं से प्रभावित हूं। अत्यधिक सिफारिश की जाती है!",
  Testimonial2:
    "इस कोल्ड वॉलेट ने मेरी उम्मीदों से अधिक किया! इसका उपयोगकर्ता-मित्रवत इंटरफ़ेस और शीर्ष-स्तरीय सुरक्षा इसे किसी भी व्यक्ति के लिए एक अनिवार्य उपकरण बनाता है जो क्रिप्टो में गंभीर है।",
  Testimonial3:
    "मैंने पहले कई कोल्ड वॉलेट आज़माए हैं, लेकिन यह सबसे अलग है। इसकी सुंदर डिज़ाइन और उन्नत सुविधाएँ मेरे क्रिप्टो संपत्तियों को आसानी से प्रबंधित करने में मदद करती हैं।",
  "John Doe": "जॉन डो",
  "Cryptocurrency Enthusiast": "क्रिप्टोकरेंसी उत्साही",
  "Jane Smith": "जेन स्मिथ",
  "Crypto Security Advocate": "क्रिप्टो सुरक्षा समर्थक",
  "Alex Johnson": "एलेक्स जॉनसन",
  "Investment Analyst": "निवेश विश्लेषक",
  "Touchscreen Interface": "टचस्क्रीन इंटरफ़ेस",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "हमारे सहज टचस्क्रीन इंटरफ़ेस के साथ आसानी से क्रिप्टो प्रबंधन का अनुभव करें, जिसे आपके डिजिटल संपत्तियों के माध्यम से त्वरित और आसान नेविगेशन के लिए डिज़ाइन किया गया है, जो त्वरित लेन-देन और सुरक्षित प्रबंधन को सक्षम बनाता है।",
  "Bluetooth Connectivity": "ब्लूटूथ कनेक्टिविटी",
  "Wireless syncing with your devices for real-time updates.":
    "अपने उपकरणों के साथ वायरलेस सिंकिंग के लिए वास्तविक समय अपडेट।",
  "Airtag Tracking": "Airtag ट्रैकिंग",
  "Track your wallet easily with built-in Airtag.":
    "निर्मित Airtag के साथ अपने बटुए को आसानी से ट्रैक करें।",
  "Secure Chip Technology": "सुरक्षित चिप प्रौद्योगिकी",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "एक उन्नत सुरक्षा चिप से लैस, जो आपके मूल्यवान डिजिटल संपत्तियों को अनधिकृत पहुंच और साइबर खतरों से मजबूत सुरक्षा सुनिश्चित करता है।",
  "Cross-Platform Support": "क्रॉस-प्लेटफॉर्म समर्थन",
  "Works with various platforms for easy accessibility.":
    "विभिन्न प्लेटफ़ॉर्म्स के साथ काम करता है ताकि आसानी से पहुँचा जा सके।",
  AboutUsDescription1:
    "LUKKEY में, हम आपकी क्रिप्टोकरेंसी संपत्तियों को सुरक्षित रूप से प्रबंधित करने के लिए उच्च गुणवत्ता वाले समाधान प्रदान करने के लिए समर्पित हैं।",
  AboutUsDescription2:
    "हमारा मुख्यालय स्विट्जरलैंड के जुग में है। अनुभवी पेशेवरों की एक टीम के साथ, हम डिजिटल मुद्रा बाजार के लगातार बदलते परिदृश्य के अनुकूल होने और नवाचार करने की कोशिश करते हैं।",
  BlockchainNetworksSupported: "समर्थित ब्लॉकचेन नेटवर्क",
  CryptocurrenciesSupported: "6,000 से अधिक क्रिप्टोकरेंसी का समर्थन",
  Years: "साल",
  ExpertiseInSecurity: "सुरक्षा में विशेषज्ञता",
  FrequentlyAskedQuestions: "सामान्य प्रश्न",
  WhatIsColdWallet: "कोल्ड वॉलेट क्या है?",
  ColdWalletDescription:
    "कोल्ड वॉलेट एक प्रकार का क्रिप्टोकरेंसी वॉलेट है जो आपके डिजिटल एसेट्स को ऑफलाइन स्टोर करता है, जिससे यह हैकिंग और अन्य ऑनलाइन खतरों से कम संवेदनशील होता है। हॉट वॉलेट के विपरीत, जो इंटरनेट से जुड़े होते हैं और बार-बार लेन-देन के लिए सुविधाजनक होते हैं, कोल्ड वॉलेट लंबी अवधि के लिए स्टोर करने के लिए बेहतर होते हैं क्योंकि ये सुरक्षा को बढ़ाते हैं।",
  HowToSetUpColdWallet: "अपना कोल्ड वॉलेट कैसे सेट करें?",
  ColdWalletSetupDescription:
    "अपने कोल्ड वॉलेट को सेट करने में आमतौर पर एक सुरक्षित और ऑफलाइन मशीन पर डिवाइस को इनिशियलाइज़ करना शामिल होता है। आपको एक रिकवरी फ़्रेज़ जनरेट करने और उसे सुरक्षित रूप से स्टोर करने की आवश्यकता होगी, जो आपके डिवाइस के खो जाने या असफल होने की स्थिति में आपके एसेट्स तक पहुँचने के लिए आवश्यक है। विस्तृत निर्देश आपके खरीदारी के साथ प्रदान किए जाते हैं, ताकि सेटअप प्रक्रिया सहज हो।",
  CryptocurrenciesCompatibleWithColdWallet:
    "आपके कोल्ड वॉलेट के साथ कौन सी क्रिप्टोकरेंसी संगत हैं?",
  CryptocurrenciesCompatibilityDescription:
    "हमारे कोल्ड वॉलेट एक विस्तृत श्रृंखला की क्रिप्टोकरेंसी का समर्थन करते हैं, जिसमें प्रमुख जैसे Bitcoin, Ethereum और Litecoin, साथ ही विभिन्न अल्टकॉइन शामिल हैं। समर्थित मुद्राओं की पूरी सूची के लिए कृपया हमारी वेबसाइट पर जाएं या उत्पाद दस्तावेज़ों को देखें।",
  HowToSecureColdWallet: "मैं अपने कोल्ड वॉलेट को सुरक्षित कैसे रख सकता हूं?",
  ColdWalletSecurityDescription:
    "अपने कोल्ड वॉलेट को सुरक्षित करने के लिए, हमेशा रिकवरी फ़्रेज़ को एक सुरक्षित और निजी स्थान पर रखें, इसे किसी के साथ साझा न करें और अतिरिक्त सुरक्षा उपायों जैसे बायोमेट्रिक लॉक या सुरक्षित कैबिनेट का उपयोग करने पर विचार करें। आधिकारिक वेबसाइट से नियमित रूप से वॉलेट का फ़र्मवेयर अपडेट करना भी कमजोरियों से सुरक्षा में मदद करता है।",
  ColdWalletNotWorking:
    "अगर मेरा कोल्ड वॉलेट काम नहीं कर रहा है या अगर मुझे कोई गलती हो रही है तो क्या करना चाहिए?",
  ColdWalletErrorDescription:
    "यदि आपके कोल्ड वॉलेट में कोई समस्या है, तो हमारे उपयोगकर्ता गाइड के समस्या निवारण अनुभाग को देखें। अधिक विशिष्ट समस्याओं के लिए, हमारी वेबसाइट के माध्यम से हमारे समर्थन टीम से संपर्क करें। समर्थन प्रक्रिया को तेज करने के लिए सुनिश्चित करें कि आपके पास आपके डिवाइस की जानकारी उपलब्ध हो।",
  Community: "समुदाय",
  "Subscribe.title": "प्रोडक्ट अपडेट्स पाएं",
  "Subscribe.subtitle":
    "हम आपके लिए क्रिप्टो ट्रेंड्स ट्रैक करते हैं। प्रोडक्ट अपडेट्स, मार्केट इनसाइट्स और एक्सक्लूसिव फायदे — सीधे आपके इनबॉक्स में।",
  "Subscribe.placeholder": "अपना ईमेल दर्ज करें",
  "Subscribe.button": "प्रोडक्ट अपडेट्स के लिए सब्सक्राइब करें",
  "Subscribe.input.aria": "ईमेल पता इनपुट",
  "Subscribe.success": "सदस्यता के लिए धन्यवाद! कृपया पुष्टि ईमेल देखें।",
  "Subscribe.error": "सदस्यता असफल रही। बाद में पुनः प्रयास करें।",
  "Subscribe.invalid": "कृपया मान्य ईमेल पता दर्ज करें।",
  "Subscribe.privacy":
    "आपका ईमेल पता केवल हमारे न्यूज़लेटर और अपडेट भेजने के लिए उपयोग किया जाएगा। आप किसी भी समय ईमेल में दिए गए लिंक से सदस्यता समाप्त कर सकते हैं।",
  "Subscribe.learnMore":
    "जानें कि हम आपके डेटा और अधिकारों का प्रबंधन कैसे करते हैं।",
  "Subscribe.popupCompact.title": "अपडेट में रहें",
  "Subscribe.popupCompact.subtitle":
    "प्रोडक्ट अपडेट और सुरक्षा जानकारी। बिना स्पैम।",
  "Subscribe.popupCompact.button": "सब्सक्राइब करें",
  "Subscribe.popupCompact.privacy":
    "सिर्फ ईमेल के लिए। कभी भी अनसब्सक्राइब करें।",
  "SubscribeConfirmed.alt.success": "सदस्यता पुष्टि हो गई",
  "SubscribeConfirmed.alt.failed": "सदस्यता विफल",
  "SubscribeConfirmed.title.success": "सदस्यता पुष्टि हो गई",
  "SubscribeConfirmed.title.failed": "सदस्यता विफल",
  "SubscribeConfirmed.message.success":
    "ईमेल की पुष्टि करने के लिए धन्यवाद। आपकी सदस्यता अब सक्रिय है। स्वागत ईमेल आपके इनबॉक्स में भेज दिया गया है।",
  "SubscribeConfirmed.message.failed":
    "पुष्टिकरण लिंक अमान्य है या उसकी समय-सीमा समाप्त हो गई है। कृपया होमपेज पर लौटें और फिर से सदस्यता लेने का प्रयास करें।",
  "SubscribeConfirmed.cta.backHome": "होम पर वापस जाएँ",
  "SubscribeConfirmed.note.unsubscribe":
    "आप हमारे ईमेल में दिए गए लिंक के माध्यम से कभी भी सदस्यता रद्द कर सकते हैं।",
  // ===== MarketView i18n =====
  "MarketView.title": "मार्केट डैशबोर्ड",
  "MarketView.loading": "लोड हो रहा है...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "यह टैब रेंडर करने में विफल रहा",
  "MarketView.unknownError": "अज्ञात त्रुटि",

  // ===== Common i18n =====
  "Common.refresh": "रीफ़्रेश",
  "Common.toggleSeriesVisibility": "इस श्रृंखला को टॉगल करें",
  "Common.error": "त्रुटि",
  "Common.dataUpdateTime": "डेटा अपडेट समय",
  "Common.loading": "लोड हो रहा है...",
  "Common.noDataSource": "कोई डेटा नहीं (डेटा स्रोत उपलब्ध नहीं)",

  // ===== Common ranges =====
  "Common.to": "तक",
  "Common.clear": "साफ़ करें",
  "Common.range.thisMonth": "इस माह",
  "Common.range.lastMonth": "पिछला माह",
  "Common.range.last2": "पिछले 2 माह",
  "Common.range.last3": "पिछले 3 माह",
  "Common.range.last6": "पिछले 6 माह",
  "Common.range.thisYear": "इस वर्ष",
  "Common.range.all": "सभी",
  "Common.range.custom": "कस्टम",
  "Common.showFilters": "फ़िल्टर दिखाएँ",
  "Common.hideFilters": "फ़िल्टर छुपाएँ",
  "Common.search": "खोजें",
  "Common.priority": "प्राथमिकता",
  "Common.owner": "ज़िम्मेदार",
  "Common.collaborator": "सहयोगी",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "बैकएंड data/youtube_stats.json डाउनलोड करें",
  "YouTubeTab.downloadJson": "youtube_stats.json डाउनलोड करें",
  "YouTubeTab.loading": "YouTube मेट्रिक्स लोड हो रहे हैं...",
  "YouTubeTab.errorHint":
    "यदि API कुंजी कॉन्फ़िगर नहीं है, तो backend/.env में YOUTUBE_API_KEY या GOOGLE_API_KEY सेट करें और बैकएंड पुनः आरंभ करें।",
  "YouTubeTab.header.totalViews": "कुल दृश्य (मल्टी-चैनल, इकाई: 10k)",
  "YouTubeTab.header.totalSubscribers": "कुल सदस्य (मल्टी-चैनल, इकाई: 10k)",
  "YouTubeTab.dist.views": "दृश्य वितरण (10k)",
  "YouTubeTab.dist.subscribers": "सदस्य वितरण (10k)",
  "YouTubeTab.card.location": "स्थान:",
  "YouTubeTab.card.registeredAt": "पंजीकृत तिथि:",
  "YouTubeTab.card.currentSubscribers": "वर्तमान सदस्य",
  "YouTubeTab.card.currentVideos": "वर्तमान वीडियो संख्या",
  "YouTubeTab.card.currentTotalViews": "वर्तमान कुल दृश्य",
  "YouTubeTab.card.currentTotalComments": "वर्तमान कुल टिप्पणियाँ",
  "YouTubeTab.chart.totalSubscribers": "कुल सदस्य",
  "YouTubeTab.chart.totalViews": "कुल दृश्य",
  "YouTubeTab.chart.totalComments": "कुल टिप्पणियाँ",
  "YouTubeTab.chart.totalVideos": "कुल वीडियो",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "बैकएंड data/x_stats.json डाउनलोड करें",
  "XTab.downloadJson": "x_stats.json डाउनलोड करें",
  "XTab.loading": "X मेट्रिक्स लोड हो रहे हैं...",
  "XTab.errorHint":
    "यदि टोकन कॉन्फ़िगर नहीं है, तो backend/.env में X_BEARER_TOKEN या TWITTER_BEARER_TOKEN सेट करें और बैकएंड पुनः आरंभ करें।",
  "XTab.header.totalFollowers": "कुल अनुयायी (मल्टी-चैनल, इकाई: 10k)",
  "XTab.header.totalEngagement":
    "कुल एंगेजमेंट (पिछली 5 पोस्ट: लाइक + रीट्वीट + रिप्लाई + उद्धरण, इकाई: 10k)",
  "XTab.dist.followers": "अनुयायी वितरण (10k)",
  "XTab.dist.engagement":
    "एंगेजमेंट वितरण (पिछली 5 पोस्ट: लाइक + रीट्वीट + रिप्लाई + उद्धरण, इकाई: 10k)",
  "XTab.card.currentFollowers": "वर्तमान अनुयायी",
  "XTab.card.currentFollowing": "वर्तमान फ़ॉलोइंग",
  "XTab.card.currentTweets": "वर्तमान ट्वीट संख्या",
  "XTab.card.recentLikes": "हाल के लाइक (पिछली 5 पोस्ट)",
  "XTab.card.recentRetweets": "हाल के रीट्वीट (पिछली 5 पोस्ट)",
  "XTab.card.recentReplies": "हाल के रिप्लाई (पिछली 5 पोस्ट)",
  "XTab.card.recentQuotes": "हाल के दृश्य (कंटेंट-स्तर, पिछली 5 पोस्ट)",
  "XTab.card.listed": "सूचीबद्ध संख्या (चैनल-स्तर)",
  "XTab.smallChart.followers": "अनुयायी",
  "XTab.smallChart.tweets": "ट्वीट",
  "XTab.smallChart.likes": "हाल के लाइक",
  "XTab.smallChart.retweets": "हाल के रीट्वीट",
  "XTab.smallChart.replies": "हाल के रिप्लाई",
  "XTab.smallChart.quotes": "हाल के दृश्य (कंटेंट-स्तर)",
  "XTab.smallChart.following": "फ़ॉलोइंग",
  "XTab.smallChart.listed": "सूचीबद्ध",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "बनाए गए महीने के अनुसार फ़िल्टर करें:",
  "Analytics.dashboardTitle": "प्रोजेक्ट हेल्थ डैशबोर्ड",
  "Analytics.metric.completionRate": "समाप्ति दर",
  "Analytics.metric.teamVelocity": "टीम वेग",
  "Analytics.metric.blockerRatio": "ब्लॉकर अनुपात",
  "Analytics.metric.workloadBalance": "कार्यभार संतुलन",
  "Analytics.charts.statusDistribution": "स्थिति वितरण",
  "Analytics.charts.statusByMonthPercent": "महीने के अनुसार स्थिति (प्रतिशत)",
  "Analytics.charts.priorityDistribution": "प्राथमिकता वितरण",
  "Analytics.charts.priorityByMonthPercent":
    "महीने के अनुसार प्राथमिकता (प्रतिशत)",
  "Analytics.charts.functionTypeDistribution": "कार्य-प्रकार वितरण",
  "Analytics.charts.functionTypeByMonthPercent":
    "महीने के अनुसार कार्य-प्रकार (प्रतिशत)",
  "Analytics.blocker.ownerPie": "ब्लॉक हुए मुद्दे · ज़िम्मेदार वितरण (डोनट)",
  "Analytics.blocker.ownerByMonth":
    "ब्लॉक हुए मुद्दे · महीने के अनुसार ज़िम्मेदार (प्रतिशत)",
  "Analytics.bug.ownerPie": "बग मुद्दे · ज़िम्मेदार वितरण (डोनट)",
  "Analytics.bug.ownerByMonth":
    "बग मुद्दे · महीने के अनुसार ज़िम्मेदार (प्रतिशत)",
  "Analytics.ownerWorkloadDistribution": "टीम कार्यभार वितरण",
  "Analytics.mode.priority": "प्राथमिकता वितरण",
  "Analytics.mode.status": "स्थिति वितरण",
  "Analytics.mode.type": "प्रकार वितरण",
  "Analytics.blocker.attentionNeeded": "तुरंत ध्यान की आवश्यकता वाले मुद्दे",
  "Analytics.common.status": "स्थिति",
  "Analytics.common.owner": "ज़िम्मेदार",
  "Analytics.insights.sectionTitle": "प्रोजेक्ट इनसाइट्स और सुझाव",
  "Analytics.insights.efficiency.title": "दक्षता सुधार सुझाव",
  "Analytics.insights.efficiency.completionRate":
    "• वर्तमान समाप्ति दर {{rate}}% है, ब्लॉकर्स पर ध्यान दें",
  "Analytics.insights.efficiency.avgVelocity":
    "• टीम का औसत वेग {{velocity}} कार्य/व्यक्ति है",
  "Analytics.insights.efficiency.workloadBalance":
    "• कार्यभार संतुलन {{balance}}% है",
  "Analytics.insights.risk.title": "जोखिम चेतावनियाँ",
  "Analytics.insights.risk.blockerRatio": "• ब्लॉकर अनुपात {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• P0 मुद्दों का अनुपात {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• उच्च प्राथमिकता वाले मुद्दों को पहले निपटाएँ",

  // ===== Kanban i18n =====
  "Kanban.title": "कानबान दृश्य",
  "Kanban.totalIssues": "कुल {{count}} मुद्दे",
  "Kanban.searchPlaceholder":
    "शीर्षक, इश्यू नंबर, ज़िम्मेदार या सहयोगी खोजें...",
  "Kanban.status.backlog": "बैकलॉग",
  "Kanban.status.inProgress": "प्रगति पर",
  "Kanban.status.blocked": "अवरुद्ध / पुष्टि लंबित",
  "Kanban.status.reviewTest": "रीव्यू / परीक्षण",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "मुद्दों की सूची",
  "List.totalIssues": "कुल {{count}} मुद्दे",
  "List.viewDetails": "विवरण देखें",
  "List.openInNewWindow": "नई विंडो में खोलें",
  "List.empty.title": "कोई मुद्दे नहीं",
  "List.empty.subtitle": "अपना कार्यप्रवाह शुरू करने के लिए पहला मुद्दा बनाएँ",

  // ===== Assets Register i18n =====
  "Assets.title": "संपत्ति रजिस्टर",
  "Assets.totalSets": "कुल सेट",
  "Assets.table.employee": "कर्मचारी",
  "Assets.table.setCount": "सेट",
  "Assets.table.model": "मॉडल",
  "Assets.total": "कुल",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "प्रोजेक्ट इश्यू ट्रैकिंग",
  "LukkeyIssues.goToDemo": "डेमो पेज पर जाएँ",
  "LukkeyIssues.githubProject": "GitHub प्रोजेक्ट ↗",
  "LukkeyIssues.githubManageIssues": "GitHub पर सीधे Issues प्रबंधित करें ↗",
  "LukkeyIssues.financeModel": "फाइनेंस मॉडल",
  "LukkeyIssues.productCoreIssues": "प्रोडक्ट कोर मुद्दे",
  "LukkeyIssues.stats.totalIssues": "📊 कुल मुद्दे",
  "LukkeyIssues.stats.completed": "✅ पूर्ण",
  "LukkeyIssues.stats.inProgress": "🔄 प्रगति पर",
  "LukkeyIssues.stats.pending": "⏳ लंबित",
  "LukkeyIssues.stats.blocked": "🚫 अवरुद्ध",
  "LukkeyIssues.stats.docs": "📚 Docs",
  "LukkeyIssues.tabs.kanban": "कानबान दृश्य",
  "LukkeyIssues.tabs.analytics": "एनालिटिक्स",
  "LukkeyIssues.tabs.market": "मार्केट डैशबोर्ड",
  "LukkeyIssues.tabs.assets": "संपत्ति रजिस्टर",
  "LukkeyIssues.shareToChatGPT": "ChatGPT के साथ LUKKEY.json खोलें", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "LUKKEY गोपनीयता नीति",
  "PrivacyPolicy.intro.p1":
    "LUKKEY में, हम मानते हैं कि गोपनीयता का सबसे सुरक्षित रूप वही है जो हमेशा उपयोगकर्ता के अपने हाथों में रहता है।",
  "PrivacyPolicy.intro.p2":
    "इसीलिए, चाहे आप LUKKEY हार्डवेयर कोल्ड वॉलेट का उपयोग करें या LUKKEY मोबाइल एप्लिकेशन (ऐप) का, हम एक अटल सिद्धांत का कड़ाई से पालन करते हैं:",
  "PrivacyPolicy.intro.p3_strong":
    "जब तक उपयोगकर्ता स्पष्ट रूप से अधिकृत न करे, हम किसी भी प्रकार की उपयोगकर्ता जानकारी न तो एकत्रित करते हैं, न संग्रहीत करते हैं, और न ही अपलोड करते हैं।",
  "PrivacyPolicy.intro.p3_tail":
    "उपयोग से संबंधित सभी डेटा केवल उपयोगकर्ता के डिवाइस में स्थानीय रूप से संग्रहीत रहता है और LUKKEY या किसी भी सर्वर को कभी प्रसारित नहीं किया जाता।",
  "PrivacyPolicy.intro.p4":
    "यह गोपनीयता नीति बताती है कि हम इस सिद्धांत को कैसे लागू करते हैं।",

  "PrivacyPolicy.s1.title": "1. लागू होने का क्षेत्र",
  "PrivacyPolicy.s1.appliesTo": "यह गोपनीयता नीति निम्न पर लागू होती है:",
  "PrivacyPolicy.s1.item.hardware": "LUKKEY हार्डवेयर कोल्ड वॉलेट",
  "PrivacyPolicy.s1.item.app": "LUKKEY मोबाइल एप्लिकेशन (ऐप)",
  "PrivacyPolicy.s1.principle":
    "दोनों “शून्य-संग्रह, शून्य-अपलोड, केवल स्थानीय संग्रहण” के एकीकृत गोपनीयता सिद्धांत का पालन करते हैं।",

  "PrivacyPolicy.s2.title": "2. वह जानकारी जो हम एकत्र नहीं करते",
  "PrivacyPolicy.s2.desc":
    "आपकी गोपनीयता की सुरक्षा हेतु, हम स्पष्ट रूप से वचन देते हैं कि हम किसी भी प्रकार की उपयोगकर्ता जानकारी एकत्र, अपलोड या संग्रहीत नहीं करते, जिनमें शामिल हैं (पर सीमित नहीं):",
  "PrivacyPolicy.s2.li.identity":
    "पहचान संबंधी जानकारी: नाम, फ़ोन नंबर, ई‑मेल पता, डाक पता",
  "PrivacyPolicy.s2.li.walletSensitive":
    "वॉलेट की संवेदनशील जानकारी: प्राइवेट की, निमोनिक वाक्यांश, keystore फ़ाइलें, वॉलेट पासवर्ड",
  "PrivacyPolicy.s2.li.blockchain":
    "ब्लॉकचेन डेटा: वॉलेट पते, लेनदेन इतिहास, परिसंपत्ति संबंधी जानकारी",
  "PrivacyPolicy.s2.li.behavior":
    "उपयोग व्यवहार: ऐप लॉग, क्लिक रिकॉर्ड, व्यवहारिक विश्लेषण",
  "PrivacyPolicy.s2.li.technical":
    "तकनीकी जानकारी: डिवाइस पहचानकर्ता, स्थान (जियो‑लोकेशन), IP पता",
  "PrivacyPolicy.s2.inShort.title": "संक्षेप में:",
  "PrivacyPolicy.s2.inShort.desc":
    "हार्डवेयर डिवाइस और ऐप में जो कुछ भी आप देखते हैं, वह केवल आपके डिवाइस पर ही मौजूद है। LUKKEY उसे एक्सेस नहीं कर सकता।",

  "PrivacyPolicy.s3.title":
    "3. हार्डवेयर कोल्ड वॉलेट की गोपनीयता और सुरक्षा डिज़ाइन",
  "PrivacyPolicy.s3.desc":
    "LUKKEY कोल्ड वॉलेट उपयोगकर्ताओं को पूर्णतः ऑफ़लाइन और सुरक्षित वातावरण प्रदान करता है। मुख्य विशेषताएँ:",
  "PrivacyPolicy.s3.h1.title": "1. सैन्य‑स्तर का सुरक्षित हार्डवेयर",
  "PrivacyPolicy.s3.h1.l1": "EAL6+ प्रमाणित Secure Element",
  "PrivacyPolicy.s3.h1.l2": "पूरे संचार मार्ग में हार्डवेयर‑स्तरीय एन्क्रिप्शन",
  "PrivacyPolicy.s3.h2.title": "2. सुरक्षा फ़ंक्शंस",
  "PrivacyPolicy.s3.h2.l1": "फिंगरप्रिंट प्रमाणीकरण",
  "PrivacyPolicy.s3.h2.l2": "प्राइवेसी मोड",
  "PrivacyPolicy.s3.h2.l3": "मल्टी‑वॉलेट पृथक प्रबंधन",
  "PrivacyPolicy.s3.h3.title": "3. पूर्ण पृथक्करण",
  "PrivacyPolicy.s3.h3.l1": "कोई इंटरनेट कनेक्टिविटी नहीं",
  "PrivacyPolicy.s3.h3.l2": "कोई डेटा‑केबल कनेक्टिविटी नहीं",
  "PrivacyPolicy.s3.h4.title": "4. छेड़छाड़‑रोधी स्व‑विनाश",
  "PrivacyPolicy.s3.h4.desc":
    "डिवाइस के खोले जाने, क्षतिग्रस्त होने या असामान्य घुसपैठ की स्थिति में Secure Element संवेदनशील डेटा को स्वतः नष्ट कर देता है ताकि प्राइवेट की निकाली न जा सके।",
  "PrivacyPolicy.s3.h5.title": "5. संवेदनशील कार्य केवल Secure Element के अंदर",
  "PrivacyPolicy.s3.h5.l1": "वॉलेट निर्माण",
  "PrivacyPolicy.s3.h5.l2": "वॉलेट आयात",
  "PrivacyPolicy.s3.h5.l3": "ट्रांज़ैक्शन साइनिंग",
  "PrivacyPolicy.s3.h5.note":
    "सभी संवेदनशील प्रक्रियाएँ 100% Secure Element के अंदर होती हैं और किसी भी असुरक्षित चिप या स्टोरेज क्षेत्र में कभी उजागर नहीं होतीं।",
  "PrivacyPolicy.s3.h6.title":
    "6. Secure Element के बाहर संवेदनशील डेटा का भंडारण नहीं",
  "PrivacyPolicy.s3.h6.desc":
    "डिवाइस के असुरक्षित स्टोरेज क्षेत्रों में प्राइवेट की, निमोनिक या अन्य कोई संवेदनशील जानकारी संग्रहित नहीं होती।",

  "PrivacyPolicy.s4.title": "4. LUKKEY ऐप की गोपनीयता और सुरक्षा डिज़ाइन",
  "PrivacyPolicy.s4.desc":
    "LUKKEY ऐप केवल सूचना दिखाने और सूचनाएँ प्रदान करने पर केंद्रित है। यह वॉलेट के संवेदनशील डेटा को हैंडल नहीं करता।",
  "PrivacyPolicy.s4.n1.title": "1. ऐप क्या नहीं करता",
  "PrivacyPolicy.s4.n1.l1": "ब्लॉकचेन वॉलेट जनरेट नहीं करता",
  "PrivacyPolicy.s4.n1.l2": "ब्लॉकचेन वॉलेट आयात नहीं करता",
  "PrivacyPolicy.s4.n1.l3":
    "प्राइवेट की या निमोनिक वाक्यांश संग्रहीत नहीं करता",
  "PrivacyPolicy.s4.n1.l4": "कोई भी उपयोगकर्ता डेटा अपलोड नहीं करता",
  "PrivacyPolicy.s4.n1.l5":
    "व्यवहारिक विश्लेषण, विज्ञापन ट्रैकिंग या डेटा संग्रहण नहीं करता",
  "PrivacyPolicy.s4.n2.title": "2. ऐप क्या करता है",
  "PrivacyPolicy.s4.n2.l1":
    "हार्डवेयर द्वारा अधिकृत सार्वजनिक रूप से उपलब्ध जानकारी प्रदर्शित करता है",
  "PrivacyPolicy.s4.n2.l2":
    "प्रत्येक अनुमति के उद्देश्य को समझाने वाला प्राइवेसी सेटिंग्स पैनल प्रदान करता है",
  "PrivacyPolicy.s4.n2.l3":
    "उपयोगकर्ता को किसी भी समय अनुमतियाँ सक्षम/अक्षम करने का पूर्ण नियंत्रण देता है",
  "PrivacyPolicy.s4.n2.l4": "संवेदनशील जानकारी का मास्किंग प्रदान करता है",
  "PrivacyPolicy.s4.n2.l5":
    "कुछ दृश्य में स्क्रीनशॉट/रिकॉर्डिंग को अक्षम करता है",
  "PrivacyPolicy.s4.n2.l6":
    "स्थानीय मिलान के माध्यम से संदिग्ध ब्लॉकचेन पतों का पता लगाता है",
  "PrivacyPolicy.s4.n2.l7":
    "खतरनाक URL, कॉन्ट्रैक्ट और पतों की सूची नियमित रूप से अपडेट करता है",
  "PrivacyPolicy.s4.n2.l8": "अपडेट प्रवाह एक‑तरफ़ा है: केवल सर्वर → डिवाइस",
  "PrivacyPolicy.s4.n2.l9":
    "अपडेट्स के दौरान कभी भी उपयोगकर्ता डेटा वापस नहीं भेजा जाता",
  "PrivacyPolicy.s4.n3.title": "3. स्थानीय भंडारण",
  "PrivacyPolicy.s4.n3.p1":
    "ऐप केवल गैर‑निजी डेटा स्थानीय रूप से संग्रहीत करता है, जैसे UI प्राथमिकताएँ, भाषा और थीम सेटिंग। यह डेटा:",
  "PrivacyPolicy.s4.n3.l1": "अपलोड नहीं किया जाता",
  "PrivacyPolicy.s4.n3.l2": "सिंक नहीं किया जाता",
  "PrivacyPolicy.s4.n3.l3": "LUKKEY के लिए सुलभ नहीं है",

  "PrivacyPolicy.s5.title": "5. डेटा संचरण और सर्वर नीति",
  "PrivacyPolicy.s5.l1":
    "LUKKEY सर्वर कोई भी उपयोगकर्ता जानकारी संग्रहीत नहीं करते",
  "PrivacyPolicy.s5.l2":
    "ऐप–सर्वर संचार केवल डेटाबेस और संस्करण अपडेट तक सीमित है",
  "PrivacyPolicy.s5.l3":
    "संचार के दौरान कोई भी उपयोगकर्ता जानकारी प्रसारित नहीं होती",
  "PrivacyPolicy.s5.l4":
    "भले ही सर्वर में सेंध लगे, उपयोगकर्ता डेटा उजागर नहीं हो सकता, क्योंकि हम ऐसी जानकारी प्राप्त ही नहीं करते",

  "PrivacyPolicy.s6.title": "6. ओपन‑सोर्स पारदर्शिता",
  "PrivacyPolicy.s6.l1": "LUKKEY ऐप का सोर्स कोड ओपन‑सोर्स है",
  "PrivacyPolicy.s6.l2":
    "LUKKEY हार्डवेयर के एम्बेडेड फ़र्मवेयर को भी ओपन‑सोर्स किया गया है",
  "PrivacyPolicy.s6.l3": "GitHub पर सभी के लिए ऑडिट हेतु पूर्णतः उपलब्ध",
  "PrivacyPolicy.s6.p": "पारदर्शिता, सुरक्षा का एक हिस्सा है।",

  "PrivacyPolicy.s7.title": "7. उपयोगकर्ता का पूर्ण नियंत्रण",
  "PrivacyPolicy.s7.p":
    "भले ही हम उपयोगकर्ता जानकारी एकत्र नहीं करते, उपयोगकर्ता अपने डिवाइस पर पूर्ण नियंत्रण बनाए रखते हैं:",
  "PrivacyPolicy.s7.l1": "आप किसी भी समय ऐप अनुमतियाँ अक्षम कर सकते हैं",
  "PrivacyPolicy.s7.l2": "आप ऐप अनइंस्टॉल कर सभी स्थानीय ऐप डेटा हटा सकते हैं",
  "PrivacyPolicy.s7.l3":
    "आप हार्डवेयर डिवाइस को रीसेट कर प्राइवेट की और वॉलेट डेटा को स्थायी रूप से मिटा सकते हैं",
  "PrivacyPolicy.s7.p2":
    "LUKKEY इन कार्रवाइयों में हस्तक्षेप नहीं करता और न ही कर सकता है।",

  "PrivacyPolicy.s8.title": "8. हमसे संपर्क करें",
  "PrivacyPolicy.s8.p":
    "यदि इस गोपनीयता नीति के संबंध में आपके कोई प्रश्न हों, तो कृपया हमसे संपर्क करें:",
  "PrivacyPolicy.s8.email": "ई‑मेल: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "पता: LUKKEY मुख्यालय, Baarerstrasse 25, 6300 Zug, Switzerland",

  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "जांच हो रही है...",
  "EmailOtp.title": "सीमित पहुँच: लॉगिन कोड पाने के लिए नाम और ई‑मेल दर्ज करें",
  "EmailOtp.nameLabel": "नाम",
  "EmailOtp.namePlaceholder": "अपना नाम दर्ज करें",
  "EmailOtp.emailLabel": "ई‑मेल",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "कोड भेजें",
  "EmailOtp.resendCode": "फिर से भेजें",
  "EmailOtp.resendWithCountdown": "{{s}} सेकंड बाद पुनः भेजें",
  "EmailOtp.codeValidityHint":
    "सत्यापन कोड 5 मिनट तक मान्य है। इसे किसी से साझा न करें।",
  "EmailOtp.codeLabel": "ई‑मेल सत्यापन कोड",
  "EmailOtp.codePlaceholder": "प्राप्त कोड दर्ज करें",
  "EmailOtp.signIn": "साइन इन",
  "EmailOtp.message.codeSent": "सत्यापन कोड आपके ई‑मेल पर भेज दिया गया है।",
  "EmailOtp.error.nameRequired": "नाम आवश्यक है",
  "EmailOtp.error.invalidEmail": "कृपया मान्य ई‑मेल पता दर्ज करें",
  "EmailOtp.error.sendFailed": "कोड भेजने में विफल। बाद में पुनः प्रयास करें।",
  "EmailOtp.error.codeRequired": "कृपया सत्यापन कोड दर्ज करें",
  "EmailOtp.error.verificationFailed": "सत्यापन विफल",
  // ===== Academy i18n =====
  "Academy.hero.alert": "सुरक्षा अनुस्मारक: लिंक हमेशा सत्यापित करें और रिकवरी फ़्रेज़ कभी साझा न करें।",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "अकादमी",
  "Academy.hero.subtitle": "क्रिप्टो सुरक्षा, स्व‑कस्टडी और LUKKEY कोल्ड वॉलेट उपयोग पर व्यावहारिक गाइड।",
  "Academy.search.placeholder": "ट्यूटोरियल, बेस्ट प्रैक्टिस और FAQs खोजें…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "लेख",
  "Academy.list.title": "नवीनतम गाइड",
  "Academy.list.viewAll": "सभी देखें",
  "Academy.list.empty": "कोई परिणाम नहीं। कोई और कीवर्ड आज़माएँ।",
  "Academy.image.placeholder": "छवि",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "अकादमी पर वापस",
  "AcademyArticle.notFound": "लेख नहीं मिला",
  "AcademyArticle.author": "लेखक",
  "AcademyArticle.unscheduled": "निर्धारित प्रकाशन समय नहीं",
  "home.hero.reserveCtaLabel": "अर्ली एक्सेस — $1",
  "home.hero.reserveCtaNote": "पूरी तरह रिफंड योग्य। खरीद की कोई प्रतिबद्धता नहीं।"
};
export default translation;
